<template>
	<div style="padding-top:80px">

		<div class="phone-from">
			<span>登录</span>
			<br />
			<span style="font-size: 0.5rem;color:grey;">无账号可以联系管理员申请</span>
		</div>
		<div class="phone-from">
			<input type="text" v-model="form.username" placeholder="账号/手机号" />
		</div>
		<div class="phone-from">
			<input type="text" v-model="form.password" placeholder="请输入密码" />
		</div>

		<div class="phone-from">
			<button class="phone-login" @click="submit">登录</button>
		</div>



		<div class="phone-from">
			<button class="phone-login" @click="pageTo('/auth/phone')">验证码登录</button>
		</div>


		<div class="phone-read">
			<input style="width: 0.5rem;height: 0.5rem;" type="checkbox" />
			<span style="font-size: 0.5rem;">我已经阅读并同意《服务协议》和《隐私政策》</span>
		</div>


		<!-- 组件使用 -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.phone-from {
		position: relative;
		/* 对于下面的获取验证码 按钮相当重要 */
		width: 16rem;
		margin: 1.2rem auto;
	}

	.phone-from span {
		/* background-color: #FFFFFF; */
	}

	.phone-from input {
		width: 12rem;
		height: 1.5rem;
		font-size: .7rem;
		text-indent: .3rem;

		border-bottom: 1px solid grey;
	}

	.phone-code {
		position: absolute;
		right: 4rem;
		top: .3rem;

		width: 4rem;
		height: 1.0rem;

		font-size: .5rem;
		/* line-height: 1.0rem; */
		cursor: pointer;
		border: 1px solid grey;
		border-radius: 1.0rem;

		text-align: center;
		color: grey;
	}

	.phone-login {
		display: block;

		width: 12rem;
		height: 1.5rem;

		font-size: .6rem;
		text-align: center;

		cursor: pointer;
		border: none;
		border-radius: 1.0rem;

		color: white;
		background-color: #00be8c;
	}

	.phone-read {
		position: absolute;
		left: 2rem;
		bottom: 1.0rem;

		margin: 1.2rem auto;
	}
</style>
<script>
	import sy from "@/sy";

	// 组件引入
	import syalert from '@/components/syalert.vue';

	export default {
		// 组件注册
		components: {
			syalert,
		},
		data() {
			return {
				form: {
					username: '',
					password: '',
				},

			}
		},
		methods:
		{
			pageTo: function(page)
			{
				if (page !== undefined)
				{
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			submit: function()
			{
				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Auth/Login',
					data: {
						username: this.form.username,
						password: this.form.password,
					},
					success: function(res)
					{

							if (res.state === '1')
							{
								console.log('获取成功:' + res.data.utoken);

								// 存储 utoken
								localStorage.setItem('utoken', res.data.utoken);
								
								// 回到源头 必须指定去哪????不然跳去哪?
								$_this.$refs.syalert_id.syalert(res.msg, 1000, function()
								{
									window.history.back();
								});
								// $_this.$router.go(-1);
								
							} else {
								$_this.$refs.syalert_id.syalert(res.msg);
							}

					}
				});
			},
		},
		created() {

			
		},
		mounted() {}

	}
</script>